module.exports = __webpack_public_path__ + "static/media/canal-new-bold.fbb06193.woff2";